<template>
    <div>
        <!-- preloader area start -->
        <!-- <div class="preloader" id="preloader">
        <div class="preloader-inner">
            <div class="spinner">
                <div class="dot1"></div>
                <div class="dot2"></div>
            </div>
        </div>
    </div> -->
        <!-- preloader area end -->

        <!-- header start -->
        <div class="header-area bg-base">
            <!-- <img class="ba-nose-img" src="demo/images/icons/1.png" alt="img"> -->
            <div class="container">
                <!-- <div class="header-top">
                    <div class="row">
                        <div class="col-6">
                            <p>8:33</p>
                        </div>
                        <div class="col-6 text-end">
                            <ul>
                                <li><img src="assets/img/icon/37.png" alt="img"></li>
                                <li><img src="assets/img/icon/38.png" alt="img"></li>
                                <li><img src="assets/img/icon/39.png" alt="img"></li>
                            </ul>
                        </div>
                    </div>
                </div> -->
                <div class="row">
                    <!-- <div>{{ $route.name }}</div> -->
                    <div class="col-sm-4 col-4 align-self-center">
                        <div class="menu-bar">
                            <img @click="$store.state.sidebarMinimize = !$store.state.sidebarMinimize"
                                v-if="$route.name == 'Home'" src="assets/img/icon/0.png" alt="logo">
                            <img v-else @click="$router.back(-1)" src="assets/img/icon/28.png" alt="img">
                        </div>
                    </div>
                    <!-- <div class="col-sm-4 col-4 text-center align-self-center text-center">
                        <a @click="$router.push('/')" class="logo">
                            <img src="assets/img/brand/logo.tp_.opt_-1.svg" width="160px"
                                data-lazy-src="assets/img/brand/logo.tp_.opt_-1.svg" alt="Travel Places">
                        </a>
                    </div> -->
                    <div class="col-sm-4 col-4 text-center align-self-center text-center">
                        <a @click="$router.push('/')" class="logo">
                            <img :src="user.companylogob64" height="77px"
                                :data-lazy-src="user.companylogob64" :alt="user.company">
                        </a>
                    </div>
                    <div class="col-sm-4 col-4 align-self-center text-end">
                        <ul class="header-right">

                            <!-- <li>
                                <a @click="$router.push('/logout')" title="Logout"> -->
                                    <!-- animated infinite swing -->
                                    <!-- <i class="fa fa-sign-out"></i>
                                </a>
                            </li> -->
                            <!-- MAYBE LATER -->
                            <!-- <li>
                                <a @click="$router.push('/notifications')">
                                    <i class="fa fa-bell animated infinite swing"></i>
                                    <span class="badge">8</span>
                                </a>
                            </li> -->
                            <li>
                                <a class="header-user hover-cursor" @click="$router.push('/settings')">
                                    <!-- <img class="mb-1" :src="user.avatarb64"
                                        alt="img"> -->
                                        <i class="fa fa-user-circle text-primary"></i>
                                        <span class="pl-1 small">{{ user.firstname }}</span> </a> 
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- header end -->

        <div class="add-balance-inner-wrap">
            <div class="container">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Add Balance</h5>
                        </div>
                        <div class="modal-body">
                            <div class="action-sheet-content">
                                <form action="../demo/pages/index.html">
                                    <div class="form-group basic">
                                        <div class="input-wrapper">
                                            <label class="label" for="account1">From</label>
                                            <select class="form-control custom-select" id="account1">
                                                <option value="0">Investment (*** 7284)</option>
                                                <option value="1">Savings (*** 5078)</option>
                                                <option value="2">Deposit (*** 2349)</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-group basic">
                                        <label class="label">Enter Amount</label>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" id="input1">$</span>
                                            </div>
                                            <input type="text" class="form-control form-control-lg" value="768">
                                        </div>
                                    </div>

                                    <div class="form-group basic">
                                        <button type="button" class="btn-c btn-blue w-100 btn-lg"
                                            data-dismiss="modal">Deposit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- navbar end -->

    </div>
</template>

<script>
import { mapGetters } from "vuex";

import TheSidebar from "./TheSidebar";

// import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
// import TheHeaderDropdownNotif from "./TheHeaderDropdownNotif";
// import TheHeaderDropdownTasks from "./TheHeaderDropdownTasks";
// import TheHeaderDropdownMssgs from "./TheHeaderDropdownMssgs";

export default {
    name: "TheHeader",
    components: {
        TheSidebar,
        // TheHeaderDropdownNotif,
        // TheHeaderDropdownTasks,
        // TheHeaderDropdownMssgs,
    },
    computed: {
        ...mapGetters(["user"]),
    },
};
</script>